import io from 'socket.io-client'
import { protocol, socketsServerUrl } from 'app/config'

class SingleSocketManager {
  client = null
  connected = false

  connect = (token, addSubscribers) => {
    if (this.connected) {
      this.disconnect()
    } else {
      this.connected = true
    }
    this.client = io(`${protocol}${socketsServerUrl}`, {
      transports: ['websocket', 'polling'],
      query: { token },
    })
    addSubscribers(this.client)
  }

  disconnect = () => {
    this.connected && this.client.close()
  }

  emit = (eventName, payload) => {
    this.client.emit('events', JSON.stringify({ eventName, payload }))
  }
}

export default new SingleSocketManager()
